import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import {
    collection,
    getDocs,
    doc,
    writeBatch
} from "firebase/firestore";
import db from "./Firebase";
import Swal from "sweetalert2";

const RefreshDownloads = () => {
    const [referralPhones, setReferralPhones] = useState([]);
    const [referralMap, setReferralMap] = useState(new Map());
    const [failedPhones, setFailedPhones] = useState([]); // Add this

    const [loaded, setLoaded] = useState(false);
    const [running, setRunning] = useState(false);
    const [result, setResult] = useState({
        referralUpdated: 0,
        referralFailed: 0
    });



    // Load phones from Firestore
    useEffect(() => {
        const preloadData = async () => {
            try {
                // 1. Load phone numbers from udhyogini_features
                const featSnap = await getDocs(collection(db, "udhyogini_features"));
                const phones = featSnap.docs
                    .map(docSnap => {
                        const d = docSnap.data();
                        return String(d.phone || d.phone_no || "").trim();
                    })
                    .filter(Boolean);
                setReferralPhones(phones);

                // 2. Load app_referral records into map
                const referralSnap = await getDocs(collection(db, "app_referral"));
                const rMap = new Map();
                referralSnap.docs.forEach(docSnap => {
                    const d = docSnap.data();
                    const phone = String(d.phone || d.phone_no || "").trim();
                    if (phone) rMap.set(phone, docSnap.id);
                });
                setReferralMap(rMap);

                setLoaded(true);
            } catch (err) {
                console.error("Preload error:", err);
                Swal.fire("Error", "Failed to preload Firestore data", "error");
            }
        };

        preloadData();
    }, []);

    // const handleSync = async () => {
    //     if (!loaded) {
    //         Swal.fire("Wait", "Still loading data...", "info");
    //         return;
    //     }

    //     setRunning(true);
    //     let referralUpdated = 0;
    //     let referralFailed = 0;

    //     const BATCH_LIMIT = 500;
    //     for (let i = 0; i < referralPhones.length; i += BATCH_LIMIT) {
    //         const chunk = referralPhones.slice(i, i + BATCH_LIMIT);
    //         const batch = writeBatch(db);

    //         chunk.forEach(phone => {
    //             const docId = referralMap.get(phone);
    //             if (docId) {
    //                 const ref = doc(db, "app_referral", docId);
    //                 batch.update(ref, { referral_code: "nascom" });
    //                 referralUpdated++;
    //             } else {
    //                 console.warn("Phone not found in app_referral:", phone);
    //                 referralFailed++;
    //             }
    //         });

    //         try {
    //             await batch.commit();
    //         } catch (err) {
    //             console.error("Batch commit failed:", err);
    //             referralFailed += chunk.length;
    //         }
    //     }

    //     setRunning(false);
    //     setResult({ referralUpdated, referralFailed });

    //     Swal.fire(
    //         "Sync Complete ✅",
    //         `Referral Code Updated: ✅ ${referralUpdated} | ❌ Failed: ${referralFailed}`,
    //         "success"
    //     );
    // };

    const handleSync = async () => {
        if (!loaded) {
            Swal.fire("Wait", "Still loading data...", "info");
            return;
        }

        setRunning(true);
        let referralUpdated = 0;
        let referralFailed = 0;
        const failedList = [];

        const BATCH_LIMIT = 500;
        for (let i = 0; i < referralPhones.length; i += BATCH_LIMIT) {
            const chunk = referralPhones.slice(i, i + BATCH_LIMIT);
            const batch = writeBatch(db);

            chunk.forEach(phone => {
                const docId = referralMap.get(phone);
                if (docId) {
                    const ref = doc(db, "app_referral", docId);
                    batch.update(ref, { referral_code: "nascom" });
                    referralUpdated++;
                } else {
                    failedList.push(phone);
                    referralFailed++;
                }
            });

            try {
                await batch.commit();
            } catch (err) {
                console.error("Batch commit failed:", err);
                // mark all chunk as failed if batch fails
                failedList.push(...chunk);
                referralFailed += chunk.length;
            }
        }

        setFailedPhones(failedList); // Store for export
        setRunning(false);
        setResult({ referralUpdated, referralFailed });

        Swal.fire(
            "Sync Complete ✅",
            `Referral Code Updated: ✅ ${referralUpdated} | ❌ Failed: ${referralFailed}`,
            "success"
        );
    };


    const exportFailedPhones = (phones) => {
        const ws = XLSX.utils.json_to_sheet(phones.map(p => ({ Phone: p })));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Failed Numbers");

        XLSX.writeFile(wb, "failed_referrals.xlsx");
    };

    return (
        <>
            <div className="container p-4">
                <h3>🔁 Bulk Sync: Nascom Users Created Account</h3>
                {!loaded ? (
                    <p>Loading data...</p>
                ) : (
                    <>
                        <p>Total Phone Numbers to Match: {referralPhones.length}</p>

                        <button
                            className="btn btn-primary d-flex align-items-center gap-2"
                            onClick={handleSync}
                            disabled={running}
                        >
                            {running ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" />
                                    <span>Syncing…</span>
                                </>
                            ) : (
                                <>🚀 Start Sync All</>
                            )}
                        </button>

                        {(result.referralUpdated || result.referralFailed) && (
                            <div className="mt-3">
                                <p>
                                    🟢 Referral Sync — ✅ {result.referralUpdated}, ❌ {result.referralFailed}
                                </p>
                            </div>
                        )}
                    </>
                )}
            </div>
            {failedPhones.length > 0 && (
                <button
                    className="btn btn-outline-danger mt-2"
                    onClick={() => exportFailedPhones(failedPhones)}
                >
                    ⬇️ Download Failed Numbers
                </button>
            )}
        </>
    );
};

export default RefreshDownloads;



// import React, { useState, useEffect } from "react";
// import {
//     collection,
//     getDocs,
//     query,
//     where,
//     doc,
//     writeBatch
// } from "firebase/firestore";
// import db from "./Firebase";
// import Swal from "sweetalert2";

// const RefreshDownloads = () => {
//     // Data & Maps
//     const [users, setUsers] = useState([]);
//     const [referralPhones, setReferralPhones] = useState([]);
//     const [profileMap, setProfileMap] = useState(new Map());
//     const [referralMap, setReferralMap] = useState(new Map());

//     const [loaded, setLoaded] = useState(false);
//     const [running, setRunning] = useState(false);
//     const [result, setResult] = useState({
//         ageUpdated: 0,
//         ageFailed: 0,
//         referralUpdated: 0,
//         referralFailed: 0
//     });

//     // Load data & build maps
//     useEffect(() => {
//         const preloadTargets = async () => {
//             try {
//                 // 1. Load all profile_type
//                 const profileSnap = await getDocs(collection(db, "profile_type"));
//                 console.log("profile_type docs:", profileSnap.docs.map(d => d.data()));
//                 const pMap = new Map();
//                 profileSnap.docs.forEach((docSnap) => {
//                     const d = docSnap.data();
//                     // adapt if your field is phone or phone_no
//                     const phone = String(d.phone_no || d.phone || "").trim();
//                     if (phone) {
//                         pMap.set(phone, docSnap.id);
//                     }
//                 });
//                 setProfileMap(pMap);

//                 // 2. Load all app_referral
//                 const referralSnap = await getDocs(collection(db, "app_referral"));
//                 console.log("app_referral docs:", referralSnap.docs.map(d => d.data()));
//                 const rMap = new Map();
//                 referralSnap.docs.forEach((docSnap) => {
//                     const d = docSnap.data();
//                     const phone = String(d.phone || d.phone_no || "").trim();
//                     if (phone) {
//                         rMap.set(phone, docSnap.id);
//                     }
//                 });
//                 setReferralMap(rMap);

//                 // 3. Load users (for age range) from funder_users_list
//                 const userSnap = await getDocs(collection(db, "funder_users_list"));
//                 console.log("funder_users_list docs:", userSnap.docs.map(d => d.data()));
//                 const usersArr = userSnap.docs
//                     .map((d) => {
//                         const dd = d.data();
//                         return {
//                             id: d.id,
//                             phone: String(dd.phone_no || dd.phone || "").trim(),
//                             age_range: dd.age_range || ""
//                         };
//                     })
//                     .filter((u) => {
//                         if (!u.phone) {
//                             console.warn("Skipping user with empty phone:", u);
//                             return false;
//                         }
//                         return true;
//                     });
//                 setUsers(usersArr);

//                 // 4. Load referralPhones list from udhyogini_features
//                 const featSnap = await getDocs(collection(db, "udhyogini_features"));
//                 console.log("udhyogini_features docs:", featSnap.docs.map(d => d.data()));
//                 const phonesArr = featSnap.docs
//                     .map((d) => {
//                         const dd = d.data();
//                         return String(dd.phone || dd.phone_no || "").trim();
//                     })
//                     .filter((p) => {
//                         if (!p) {
//                             console.warn("Skipping feature doc with empty phone:",);
//                             return false;
//                         }
//                         return true;
//                     });
//                 setReferralPhones(phonesArr);

//                 setLoaded(true);
//             } catch (err) {
//                 console.error("Preload error:", err);
//                 Swal.fire("Error", "Failed to preload data", "error");
//             }
//         };

//         preloadTargets();
//     }, []);

//     const handleRunBoth = async () => {
//         if (!loaded) {
//             Swal.fire("Wait", "Still loading data...", "info");
//             return;
//         }

//         setRunning(true);

//         let ageUpdated = 0;
//         let ageFailed = 0;
//         let referralUpdated = 0;
//         let referralFailed = 0;

//         // Sync age_range → profile_type
//         const AGE_BATCH_LIMIT = 400;
//         for (let i = 0; i < users.length; i += AGE_BATCH_LIMIT) {
//             const chunk = users.slice(i, i + AGE_BATCH_LIMIT);
//             const batch = writeBatch(db);

//             chunk.forEach((u) => {
//                 const docId = profileMap.get(u.phone);
//                 if (docId) {
//                     const ref = doc(db, "profile_type", docId);
//                     batch.update(ref, { age_range: u.age_range });
//                     ageUpdated++;
//                 } else {
//                     console.warn("No profile_type mapping for user.phone:", u.phone);
//                     ageFailed++;
//                 }
//             });

//             try {
//                 await batch.commit();
//             } catch (err) {
//                 console.error("Age batch commit error:", err);
//                 ageFailed += chunk.length;
//             }
//         }

//         // Sync referral_code → app_referral
//         const REFERRAL_BATCH_LIMIT = 500;
//         for (let i = 0; i < referralPhones.length; i += REFERRAL_BATCH_LIMIT) {
//             const chunk = referralPhones.slice(i, i + REFERRAL_BATCH_LIMIT);
//             const batch = writeBatch(db);

//             chunk.forEach((phone) => {
//                 const docId = referralMap.get(phone);
//                 if (docId) {
//                     const ref = doc(db, "app_referral", docId);
//                     batch.update(ref, { referral_code: "nascom" });
//                     referralUpdated++;
//                 } else {
//                     console.warn("No app_referral mapping for phone:", phone);
//                     referralFailed++;
//                 }
//             });

//             try {
//                 await batch.commit();
//             } catch (err) {
//                 console.error("Referral batch commit error:", err);
//                 referralFailed += chunk.length;
//             }
//         }

//         setRunning(false);
//         setResult({ ageUpdated, ageFailed, referralUpdated, referralFailed });

//         Swal.fire(
//             "Sync Complete",
//             `→ Updated: ${referralUpdated}`,
//             // `Age → Updated: ${ageUpdated}, Failed: ${ageFailed}\nReferral → Updated: ${referralUpdated}, Failed: ${referralFailed}`,
//             "success"
//         );
//     };

//     return (
//         <div className="container p-4">
//             <h3>🔁 Bulk Sync: Nascom Users Created Account</h3>
//             {!loaded ? (
//                 <p>Loading data...</p>
//             ) : (
//                 <>
//                     <p>Total Users (for age sync): {users.length}</p>
//                     {/* <p>Total Referral Phones: {referralPhones.length}</p> */}

//                     <button
//                         className="btn btn-primary d-flex align-items-center gap-2"
//                         onClick={handleRunBoth}
//                         disabled={running}
//                     >
//                         {running ? (
//                             <>
//                                 <span
//                                     className="spinner-border spinner-border-sm"
//                                     role="status"
//                                     aria-hidden="true"
//                                 ></span>
//                                 <span>Syncing…</span>
//                             </>
//                         ) : (
//                             <>🚀 Start Sync All</>
//                         )}
//                     </button>

//                     {(result.ageUpdated || result.ageFailed || result.referralUpdated || result.referralFailed) && (
//                         <div className="mt-3">
//                             <p>
//                                 🔵 Age Sync — ✅ {result.ageUpdated}, ❌ {result.ageFailed}
//                             </p>
//                             <p>
//                                 🟢 Referral Sync — ✅ {result.referralUpdated}, ❌ {result.referralFailed}
//                             </p>
//                         </div>
//                     )}
//                 </>
//             )}
//         </div>
//     );
// };

// export default RefreshDownloads;
